import VProgressCircular from './VProgressCircular'

VProgressCircular.install = function install (Vue) {
  Vue.component(VProgressCircular.name, VProgressCircular)
}

export default VProgressCircular



// WEBPACK FOOTER //
// ./src/components/VProgressCircular/index.js